import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  color: #161d1f;
`;

export const Title = styled.h1`
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 28px;
  text-align: left;
`;

export const Subtitle = styled.h2`
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  text-align: left;
`;

export const Content = styled.div`
  width: 100%;
  padding: 24px;
`;

export const Description = styled.div`
  margin-bottom: 24px;

  span {
    width: 100%;
    margin-bottom: 4px;
    display: block;
  }

  ul {
    list-style-type: disc;
    padding-left: 16px;
  }

  ol {
    list-style-type: decimal;
    padding-left: 16px;
  }
`;
